module.exports = __webpack_public_path__ + "img/oufu_130x150x14_5b.prt.59398377.jpg";